<template>
  <div class="information-section">
    <b-row class="d-flex align-items-center mb-2 mt-1 px-2">
      <b-col>
        <span class="ap-title ap-title__main">{{ $tc('globalLocator.sections.caseData') }}</span>
      </b-col>
    </b-row>

    <b-form-row class="px-2 pt-2">
      <b-col lg="6">
        <div class="info-card">
          <b-form-row class="h-100">
            <b-col
              cols="5"
              class="flex-row-center"
            >
              <section-info-col-type-date
                :label="$tc('globalLocator.labels.registryDate')"
                :date="caseStudy.registrationDate"
                col-class="flex-column-center"
              />
            </b-col>
            <b-col
              cols="7"
              class="flex-row-center"
            >
              <section-info-col-type
                :label="$tc('globalLocator.labels.laboratory')"
                :data="caseStudy.laboratory"
                col-class="flex-column-center"
              >
                <template #default="{ data }">
                  {{ data.labName }}
                </template>
              </section-info-col-type>
            </b-col>
          </b-form-row>
        </div>
      </b-col>
      <b-col lg="6">
        <div class="info-card">
          <b-form-row class="h-100">
            <b-col class="flex-row-center">
              <section-info-col-type-date
                :label="$tc('globalLocator.labels.informedDate')"
                :date="caseStudy.informedDate"
                col-class="flex-column-center"
              />
            </b-col>
            <b-col class="flex-row-center">
              <section-info-col-type-date
                :label="$tc('globalLocator.labels.transcriptionDate')"
                :date="caseStudy.transcriptionDate"
                col-class="flex-column-center"
              />
            </b-col>
            <b-col class="flex-row-center">
              <section-info-col-type-date
                :label="$tc('globalLocator.labels.validationDate')"
                :date="caseStudy.validationDate"
                col-class="flex-column-center"
              />
            </b-col>
          </b-form-row>
        </div>
      </b-col>
    </b-form-row>

    <b-row class="mt-4 pt-1 px-2">
      <b-col>
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.register')"
          :personnel="caseStudy.registrar"
        />
      </b-col>
      <b-col>
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.responsiblePathologist')"
          :personnel="caseStudy.pathologist"
        />
      </b-col>
      <b-col>
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.responsibleResident')"
          :personnel="caseStudy.resident"
        />
      </b-col>
    </b-row>

    <b-row class="px-2 mt-4">
      <b-col cols="12">
        <hr>
      </b-col>
      <b-col
        cols="4"
        class="my-2"
      >
        <section-info-col-type
          :label="$tc('globalLocator.labels.patientAgeCase')"
          :data="patientAge"
        />
      </b-col>
      <b-col
        cols="4"
        class="my-2"
      >
        <section-info-col-type
          :label="$tc('globalLocator.labels.regime')"
          :data="caseStudy.regime"
        >
          <template #default="{ data }">
            {{ data.name }}
          </template>
        </section-info-col-type>
      </b-col>
      <b-col
        cols="4"
        class="my-2"
      >
        <section-info-col-type
          :label="$tc('globalLocator.labels.requestLabel')"
          :data="caseStudy.requestLabel"
        />
      </b-col>
      <b-col
        cols="12"
        class="my-2"
      >
        <section-info-col-type
          :label="$tc('globalLocator.labels.observations')"
          :data="caseStudy.notes"
        />
      </b-col>
      <b-col
        cols="12"
        class="my-2"
      >
        <section-info-col-type
          :label="$tc('globalLocator.labels.relevantClinicalData')"
          :data="caseStudy.clinicalData"
        />
      </b-col>
    </b-row>

    <b-row class="px-2 pt-4">
      <b-col
        cols="auto"
        class="d-flex align-items-center"
      >
        <span class="ap-title ap-title__divider">{{ $tc('globalLocator.labels.requester') }}</span>
      </b-col>
      <b-col>
        <hr>
      </b-col>
    </b-row>

    <b-row class="px-2 mt-1">
      <b-col cols="4">
        <section-info-col-type
          :label="$tc('globalLocator.labels.cenPhysName')"
          :data="caseStudy.physicianDepartment"
        >
          <template #default="{ data }">
            {{ data.center.name }}
          </template>
        </section-info-col-type>
      </b-col>
      <b-col cols="4">
        <section-info-col-type
          :label="$tc('globalLocator.labels.unit')"
          :data="caseStudy.physicianDepartment"
        >
          <template #default="{ data }">
            {{ data.name }}
          </template>
        </section-info-col-type>
      </b-col>
      <b-col cols="4">
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.professional')"
          :personnel="caseStudy.physicianPetitioner"
        />
      </b-col>
    </b-row>

    <b-row class="px-2 pt-4">
      <b-col
        cols="auto"
        class="d-flex align-items-center"
      >
        <span class="ap-title ap-title__divider">{{ $tc('globalLocator.labels.destination') }}</span>
      </b-col>
      <b-col>
        <hr>
      </b-col>
    </b-row>

    <b-row class="px-2 mt-1">
      <b-col cols="4">
        <section-info-col-type
          :label="$tc('globalLocator.labels.cenPhysName')"
          :data="caseStudy.destinationDepartment"
        >
          <template #default="{ data }">
            {{ data.center.name }}
          </template>
        </section-info-col-type>
      </b-col>
      <b-col cols="4">
        <section-info-col-type
          :label="$tc('globalLocator.labels.unit')"
          :data="caseStudy.destinationDepartment"
        >
          <template #default="{ data }">
            {{ data.name }}
          </template>
        </section-info-col-type>
      </b-col>
      <b-col cols="4">
        <section-info-col-type
          :label="$tc('globalLocator.labels.receiver')"
          :data="caseStudy.receiver"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SectionInfoColType from '@/modules/globalLocatorModule/sections/info/col-types/section-info-col-type.vue'
import SectionInfoColTypeDate from '@/modules/globalLocatorModule/sections/info/col-types/date/section-info-col-type-date.vue'
import SectionInfoColTypePersonnel from '@/modules/globalLocatorModule/sections/info/col-types/personnel/section-info-col-type-personnel.vue'
import { mountPatientAgeString } from '@/utils/fieldTransformations'

export default {
    name: 'CaseInfoSection',
    components: {
        SectionInfoColType,
        SectionInfoColTypeDate,
        SectionInfoColTypePersonnel
    },
    props: {
        caseStudy: { type: Object, required: true }
    },
    computed: {
        patientAge() {
            return this.caseStudy
                ? mountPatientAgeString(this.caseStudy.patientAge)
                : null
        }
    }
}
</script>
